import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useDatosUser } from "../context/userContext";
import { URLS } from '../context/urls';
export const useAuth = () => {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const { changeName, changeCompleted, changeWuujuID, changePhone, changeNombreCompleto } = useDatosUser();

    useEffect(() => {
        axios.get(URLS.API_AUTH_USER , { withCredentials: true })
            .then(response => {
                console.log(`Hola, ${response.data.username}!`);
                changeName(response.data.firstname);
                changeWuujuID(response.data.wuuju_id);
                changePhone(response.data.phone);
                changeNombreCompleto(response.data.username)
                setIsAuthenticated(true);
                if (response.data.birthdate){
                    changeCompleted(true);
                }
            })
            .catch(error => {
                console.error('No autenticado:', error);
                setIsAuthenticated(false);
            });
    }, [navigate, changeCompleted, changeName, changeWuujuID, changePhone]);

    return isAuthenticated;
};